import { atomWithImmer } from "jotai-immer";

export interface SelectedLens {
    id: string;
    name: string;
}

export const selectedLensAtom = atomWithImmer<SelectedLens | null>(null);
